export default "__VITE_ASSET__WlPmCmSD__"